import usePagination from "@/hooks/usePagination";
import { useMemo } from "react";
import useGetValidatedPublicProjects from "./useGetValidatedPublicProjects";

export const useGetValidatedPublicProjectPagination = ({
	status,
	sectoralScopeId,
}: {
	status: string[];
	sectoralScopeId?: string;
}) => {
	const pagination = usePagination();
	const validatedPublicProjects = useGetValidatedPublicProjects(
		pagination.limit,
		pagination.offset,
		status,
		sectoralScopeId,
	);
	return useMemo(
		() => ({
			validatedPublicProjects,
			pagination,
		}),
		[validatedPublicProjects, pagination],
	);
};
